import React from 'react'
import SectionLoader from './SectionLoader'
import BlockLoader from './BlockLoader';
import SnippetLoader from './SnippetLoader';
import Reference from './Reference';
import OtherLoader from './OtherLoader';
import RowLoader from './RowLoader';

const MainLoader = ( { contentCollection, collectionSettings } ) => {
    return(<>
        {contentCollection && contentCollection.map((item, index) => {
        switch(item.type) {
            case 'section':
                return <SectionLoader key={item.id} item={item} collectionSettings={collectionSettings}/>;
            case 'row':
                return <RowLoader key={item.id} item={item} collectionSettings={collectionSettings}/>;
            case 'block':
                return <BlockLoader key={item.id} item={item} collectionSettings={collectionSettings}/>;
            case 'snippet':
                return <SnippetLoader key={item.id} item={item} collectionSettings={collectionSettings}/>;
            case 'reference':
                return <Reference key={item.id} reference={item.reference} collectionSettings={collectionSettings}/>;
            case 'form':
                return <OtherLoader key={item.id} item={item} collectionSettings={collectionSettings}/>;
            default:
                return null;
        }
    })}</>)
}

export default MainLoader